import {
    UserInfoWrap,
    Avatar,
    UserInfoBody,
    Username,
    JoinAt,
    Gender,
    ButtonChooseImage,
    InputFile,
    SocialLogin,
    UserGender
} from './userInfoElements'
import moment from 'moment'
import { useSelector, useDispatch } from 'react-redux'
import { updateProfile } from '../../../store/reducer/userSlice'
import { useState } from 'react'
import Loading from '../../../components/loading'

const UserInfo = ({large}) => {
    const { user } = useSelector(state => state.user)
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const handleChangeAvatar = async e => {
        const formData = new FormData()
        formData.append('avatar', e.currentTarget.files[0])
        setLoading(true)
        await dispatch(updateProfile(formData))
        setLoading(false)
    }


    const button = user.facebookId ? <SocialLogin>Bạn đang đăng nhập bằng tài khoản Facebook</SocialLogin> : user.googleId ? <SocialLogin>Bạn đang đăng nhập bằng tài khoản Google</SocialLogin>: 
    <>
        <ButtonChooseImage htmlFor="avatar">
            Thay đổi ảnh đại diện
            <InputFile onChange={handleChangeAvatar} type="file" name="avatar" id="avatar" accept=".jpg, .jpeg, .png" />
        </ButtonChooseImage>
    </>

    return (
        <>
            {loading && <Loading />}
            <UserInfoWrap>
                <Avatar large={large} src={user.avatar} alt={user.username} />
                <UserInfoBody>
                    <Username large={large}>{user.username}</Username>
                    <JoinAt large={large}>Tham gia: {moment(user.createdAt).format('DD/MM/yyyy')}</JoinAt>
                    <Gender>Giới tính: <UserGender>{user.gender}</UserGender></Gender>
                    {large && button}
                </UserInfoBody>
            </UserInfoWrap>
        </>
    )
}

export default UserInfo
